export default ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];